export default __webpack_public_path__ + "static/media/0315.be6545fc.jpg";